import { render, staticRenderFns } from "./blog-ad.vue?vue&type=template&id=4f502d4e&scoped=true&"
import script from "./blog-ad.vue?vue&type=script&lang=js&"
export * from "./blog-ad.vue?vue&type=script&lang=js&"
import style0 from "./blog-ad.vue?vue&type=style&index=0&id=4f502d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f502d4e",
  null
  
)

export default component.exports